import React from 'react';

export default () => (
  <svg fill="currentColor">
    <path d="M16.509 16.901c0-.479.5-.893 1.262-1.085 5.2-1.308 8.482-4.6 8.128-8.137-.4-4.116-5.6-7.4-12.117-7.658a17.622 17.622 0 00-9.694 2.2C1.513 3.753-.001 5.954-.001 8.188v2.235h7.068V8.189a3.223 3.223 0 011.868-2.712 8.02 8.02 0 014.443-.989c2.928.128 5.3 1.627 5.5 3.478.151 1.6-1.363 3.1-3.736 3.7-3.484.862-5.705 2.9-5.705 5.233v2.234h7.068zM10.285 20.411h5.382v4.467h-5.382z" />
  </svg>
);
